import { z } from "zod";
import { moneyField, nonNegativeInt, optionalText, optionalUuid } from "./common.js";
export const workCenterSchema = z.object({
    code: z.string().trim().min(1, "Code is required.").max(16),
    name: z.string().trim().min(1, "Name is required.").max(120),
    capacityNote: optionalText(200),
    hourlyRate: moneyField.optional(),
});
export const materialSchema = z.object({
    sku: z.string().trim().min(1, "SKU is required.").max(40),
    name: z.string().trim().min(1, "Name is required.").max(160),
    category: optionalText(80),
    unitOfMeasure: z.string().trim().min(1, "Unit is required.").max(20),
    standardCost: moneyField.optional(),
    reorderPoint: moneyField.optional(),
});
export const productSchema = z.object({
    code: z.string().trim().min(1, "Code is required.").max(40),
    name: z.string().trim().min(1, "Name is required.").max(160),
    kind: z.enum(["equipment", "fabricated", "component", "service"]).default("equipment"),
});
export const routingStepSchema = z.object({
    sequence: nonNegativeInt,
    workCenterId: optionalUuid(),
    description: z.string().trim().min(1, "Step description is required.").max(200),
    setupMinutes: nonNegativeInt,
    runMinutesPerUnit: z.number().min(0).max(60_000),
    outsideProcess: z.boolean().default(false),
});
export const bomLineSchema = z.object({
    materialId: z.string().uuid("Invalid material id."),
    quantityPer: z
        .string()
        .trim()
        .regex(/^\d+(\.\d{1,4})?$/, "Invalid quantity."),
    scrapFactor: z
        .string()
        .trim()
        .regex(/^\d+(\.\d{1,4})?$/, "Invalid scrap factor.")
        .default("0"),
});
export const productRevisionSchema = z.object({
    description: optionalText(1000),
    standardCost: moneyField.optional(),
    routing: z.array(routingStepSchema).default([]),
    bom: z.array(bomLineSchema).default([]),
});
export const productIdParamSchema = z.object({
    id: z.string().uuid("Invalid product id."),
});
//# sourceMappingURL=catalog.js.map